<template>
  <div class="match-info-teams flex flex-center-vertical">
    <span class="match-display-id font-bold text-center flex-noshrink">
      {{ matchDisplayId }}
    </span>
    <span
      class="match-status text-center flex-noshrink text-cut"
      v-if="!isServer">
      {{ periodTime }}
    </span>
    <span
      class="match-name flex"
      :class="{ 'pad-left': isServer }">
      <span class="team flex-center-vertical flex-noshrink">
        <transition name="slide-server">
          <i
            class="server"
            v-if="matchStatus.server === 1"
          />
        </transition>
        <card-red
          :count="matchStatus.redCards[0]"
          v-if="matchStatus.redCards && matchStatus.redCards[0]"
        />
        {{ matchTeams[0].nameShort }}
      </span>
      <span class="team-separator text-center flex-noshrink">
        {{ teamSeparator }}
      </span>
      <span class="team flex-center-vertical flex-noshrink">
        <transition name="slide-server">
          <i
            class="server"
            v-if="matchStatus.server === 2"
          />
        </transition>
        <card-red
          :count="matchStatus.redCards[1]"
          v-if="matchStatus.redCards && matchStatus.redCards[1]"
        />
        {{ matchTeams[1].nameShort }}
      </span>
    </span>
  </div>
</template>

<script>
import { server } from '@/services/mixins';
import CardRed from '@/components/common/card-red/CardRed.vue';

export default {
  name: 'MatchInfoTeams',
  mixins: [server],
  components: {
    CardRed,
  },
  props: {
    idMatch: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      teamSeparator: '-',
    };
  },
  computed: {
    matchDisplayId() {
      return this.$store.getters.getMatchIdDisplay(this.idMatch);
    },
    matchStatus() {
      return this.$store.getters.getMatchStatus(this.idMatch);
    },
    matchTeams() {
      return this.$store.getters.getMatchTeams(this.idMatch);
    },
    periodTime() {
      const matchStatus = this.$store.getters.getMatchStatus(this.idMatch);
      const sport = this.$store.getters.getSport(this.idMatch);

      return (matchStatus.overs && sport.id === 21) ? `${matchStatus.overs}o` : matchStatus.periodTime;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/style/variables";

.match-info-teams {
  height: 100%;
  margin-right: $match-results-width;
}

.match-display-id {
  width: $match-display-id-width;
  padding-left: $match-vertical-line-width;
  background-color: $match-id-color-back;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  font-size: 0.875rem;
}

.match-status {
  width: $match-status-width;
  height: 100%;
  color: $color-important;
  font-weight: $font-weight-bold;
  font-size: 0.8125rem;
}

.match-name {
  position: relative;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  font-size: 1.125rem;
  font-weight: 500;
  &.pad-left {
    padding-left: $match-name-pad-left;
  }

  .team {
    position: relative;
    height: calc(5vh - 2px);
    overflow: hidden;
    &:first-child {
      max-width: calc(50% - 15px);
    }

    &:last-child {
      padding-left: 5px;
    }
  }

  .team-separator {
    width: $match-team-separator-width;
  }

  .important {
    color: $color-important;
  }
}

.server {
  position: absolute;
  left: 0;
  bottom: 0;
  width: $match-server-width;
  height: $match-server-height;
  border-top-left-radius: $match-server-height;
  border-top-right-radius: $match-server-height;
  background-color: $color-important-special;
}
</style>
